export const VEHICLES_LIST_FILTERED = "VEHICLES_LIST_FILTERED";
export const VEHICLES_LIST_FILTERED_SUCCESS = "VEHICLES_LIST_FILTERED_SUCCESS";
export const VEHICLES_LIST_FILTERED_ERROR = "VEHICLES_LIST_FILTERED_ERROR";